import React, { useState, useEffect } from 'react'
import UserClient from '../../api-services/user/user-client';
import Joi from "joi-browser";
import { useTranslation } from "react-i18next";
import { validateForm } from "../../../common/validation/validation";
import HandlingResponse from "../../../common/handling-response/handlingResponse";

const UserSettings = ({userId, connections, setConnections }) => {
    const { t } = useTranslation();
    const client = new UserClient();
  
    const [errors, setErrors] = useState({});
    const schema = {
      connections: Joi.number().min(0).max(2147483647).required(),
    };
  
    const killSessions = async () => {
      let response = await client.killSessions(userId);
      let res = HandlingResponse(response);
      return res;
    };
  
    const changeNumberOfConnections = async () => {
      const errorsResult = validateForm({ connections: connections }, schema, t);
      setErrors(errorsResult);
      if (!errorsResult) {
        let response = await client.changeNumberOfConnections(
          userId,
          parseInt(connections)
        );
        let handledResponse = HandlingResponse(response);
        if(handledResponse !== "Error") setConnections(handledResponse);
      }
    };
  
    return (
      <>
        <div className="row">
          <div className="col-md-8">
            <label>Број конекција</label>
            <input
              className="form-control"
              type="text"
              name="connections"
              value={connections}
              onChange={(e) => setConnections(e.target.value)}
            />
            {errors?.connections && (
              <div className="text-danger">{errors.connections}</div>
            )}
          </div>
          <div className="col-md-4" style={{ marginTop: "28px" }}>
            <button
              type="button"
              className="btn btn-primary"
              onClick={changeNumberOfConnections}
            >
              Промени број конекција
            </button>
          </div>
        </div>
        <br />
        <div>
          <button
            type="button"
            className="btn btn-primary"
            onClick={killSessions}
          >
            Одјави корисника са свих уређаја
          </button>
        </div>
        <br />
      </>
    );
}

export default UserSettings
